module.exports = __webpack_public_path__ + "static/media/news.ebd873a6.svg";